import React, { Component } from "react";

class PaymentButton extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://www.convergepay.com/hosted-payments/buy_button_script/486a32587843586b536f53794b386d414535785670774141415a50574e393249";
    this.div.appendChild(script);
  }
  render() {
    return (
      <div ref={(el) => (this.div = el)}>
        {" "}
        <button className="payment-button">Online Payments</button>
      </div>
    );
  }
}

export default PaymentButton;
